<template>
  <div
    class="navigation-children js-header-navigation-ir"
    id="js-navigation-children-ir"
  >
    <div class="l-container l-container-padding">
      <div class="navigation-children-inner">
        <div class="navigation-children-title">
          <div class="navigation-children-title-main">IR情報</div>
          <div class="navigation-children-title-sub">INVESTOR RELATIONS</div>
        </div>
        <ul class="navigation-children-lists">
          <li
            class="navigation-children-lists-item"
            v-for="menu in menus"
            :key="menu.path"
            :class="{ 'is-current': currentPath === menu.path }"
          >
            <a :href="menu.path">{{ menu.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Menus from "@/mixins/irMenus.js";

export default {
  mixins: [Menus],
  computed: {
    currentPath() {
      return "/ir" + this.$route.path;
    },
    menus() {
      return this.irTop.concat(this.irMenus);
    },
  },
};
</script>
